"use strict";
/**
 * List of all file types and their extensions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.pdf = exports.word = exports.videos = exports.images = exports.powerpoints = exports.spreadsheets = void 0;
exports.spreadsheets = ['.xls', '.xlsx'];
exports.powerpoints = ['.ppt', '.pptx'];
exports.images = ['.jpg', '.jpeg', '.gif', '.png', '.tiff', '.svg'];
exports.videos = ['.mp4', '.mov'];
exports.word = ['.doc', '.docx'];
exports.pdf = ['.pdf'];
//# sourceMappingURL=fileTypeExtensions.js.map